import instance from "../api";

export const updateUserInfo = async (data: any) => {
    try {
        const query = new URLSearchParams(data).toString();
        const response = await instance.put<any>(`/User/UserUpdate?${query}`);
        return response.data;
    } catch (error) {
        return (error as any).response;
      }
};